import { useGlobalStore as d } from "@sunrise/shared";
const s = 0;
function c(n) {
  const t = e(n);
  return t ? t.placeholderMinHeight : s;
}
function u(n) {
  const t = e(n);
  return t ? t.id : "";
}
function l(n) {
  return !!e(n);
}
function e(n) {
  const t = d(), r = t.adsEnabled, o = t.ads;
  if (!(!r || !o))
    return o.adUnits.find((i) => i.position === n);
}
export {
  u as getFullId,
  c as getMaxHeight,
  l as isPlacementIdEnabled
};
